import { useRef } from 'react';

import { ConsignmentEditForm, type ConsignmentEditFormRef } from '@/widgets/consignment-edit-form';

import { useConsignmentNavigation, useConsignmentEdit } from '../lib';
import { PageHeader, NavigationControls, SaveButton, EmptyState } from './index';

export function ConsignmentEditPage() {
  const formRef = useRef<ConsignmentEditFormRef>(null);

  const {
    currentConsignmentId,
    isMultipleConsignments,
    currentIndex,
    totalConsignments,
    canGoPrevious,
    canGoNext,
    handlePrevious,
    handleNext,
    handleBack
  } = useConsignmentNavigation();

  const { handleSave, isLoading, consignmentData, isReadOnly } = useConsignmentEdit(currentConsignmentId);

  const handleFormSubmit = () => {
    formRef.current?.submit();
  };

  if (!currentConsignmentId) {
    return <EmptyState />;
  }

  return (
    <div className="mx-auto py-6 space-y-6">
      <div className="flex items-center justify-between">
        <PageHeader onBack={handleBack} />

        {isMultipleConsignments && (
          <NavigationControls
            currentIndex={currentIndex}
            totalConsignments={totalConsignments}
            canGoPrevious={canGoPrevious}
            canGoNext={canGoNext}
            onPrevious={handlePrevious}
            onNext={handleNext}
          />
        )}

        <SaveButton onClick={handleFormSubmit} isLoading={isLoading} isReadOnly={isReadOnly} />
      </div>

      <ConsignmentEditForm
        ref={formRef}
        consignmentId={currentConsignmentId}
        consignmentData={consignmentData}
        isReadOnly={isReadOnly}
        isLoading={isLoading}
        onSave={handleSave}
      />
    </div>
  );
}
